export default __webpack_public_path__ + "static/media/2-tablet.d1d5f272.jpg";